// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8Z',
  'M10.8 8C10.8 9.55 9.55 10.8 8 10.8C6.45 10.8 5.2 9.55 5.2 8C5.2 6.45 6.45 5.2 8 5.2C9.55 5.2 10.8 6.45 10.8 8Z',
  'M6.02 6.02L3.4 3.4',
  'M9.98 6.02L12.6 3.4',
  'M9.98 9.98L12.6 12.6',
  'M6.02 9.98L3.4 12.6',
];
